import React, {useEffect, useState} from "react";
import {getMerchantCapabilities} from "../../../api";
import {SellAddressesSection} from "./SellAddressesSection";

export function MerchantSellAddressesSection({merchantId, token}: {merchantId: string; token: string | null}): JSX.Element | null {
    const [enabled, setEnabled] = useState<boolean | null>(null);
    const [failed, setFailed] = useState(false);
    const [attempt, setAttempt] = useState(0);

    useEffect(() => {
        let cancelled = false;
        setEnabled(null);
        setFailed(false);
        if (token) {
            getMerchantCapabilities(token, merchantId)
                .then(({items}) => {
                    if (!cancelled) setEnabled(items.some(item => item.name === "exchange.workflow" && item.enabled));
                })
                .catch(() => {if (!cancelled) setFailed(true);});
        }
        return () => {cancelled = true;};
    }, [merchantId, token, attempt]);

    if (!token || enabled === false) return null;
    if (failed) return <section className="merchant-rate-block">
        <div className="section-header">
            <h3>Адреса продажи USDT (TRC20)</h3>
            <button className="btn btn-ghost btn-sm" type="button" onClick={() => setAttempt(value => value + 1)}>Повторить проверку</button>
        </div>
        <div className="details-action-error" role="alert">Не удалось проверить доступность обмена. Повторите проверку, чтобы открыть управление адресами.</div>
    </section>;
    if (enabled === null) return <p className="section-hint" role="status">Проверяем доступность адресов обмена…</p>;
    return <SellAddressesSection merchantId={merchantId} token={token}/>;
}
